import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import naive from 'naive-ui'
import { toastPlugin } from '@shared/plugins/toastPlugin.js'
import App from './App.vue'
import router from './router'

// Import Intercom Design System styles
import '@shared/styles/intercom-tokens.css'
import '@shared/styles/intercom-base.css'
import '@shared/styles/intercom-dark.css'
import '@shared/styles/intercom-toast.css'

// Import locale messages
import en_IN from './locales/en_IN.json'
import ta_IN from './locales/ta_IN.json'

// Detect browser language and get saved locale
const detectLocale = () => {
  const saved = localStorage.getItem('library_locale')
  if (saved) return saved

  // Detect browser language (Tamil = ta, ta-IN, etc.)
  const browserLang = navigator.language || navigator.userLanguage || ''
  if (browserLang.startsWith('ta')) {
    localStorage.setItem('library_locale', 'ta_IN')
    return 'ta_IN'
  }
  return 'en_IN'
}

// Create i18n instance
const i18n = createI18n({
  legacy: false,
  locale: detectLocale(),
  fallbackLocale: 'en_IN',
  missingWarn: false,
  fallbackWarn: false,
  messages: {
    en_IN,
    ta_IN,
  },
})

// Create Vue app
const app = createApp(App)

// Install plugins
app.use(router)
app.use(i18n)
app.use(naive)
app.use(toastPlugin)

// Mount app
app.mount('#app')
